import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/design-system/components/Button/Button';

/** Plain-language fallback for RouteErrorBoundary, in the dark design system. */
export function RouteErrorFallback({ onReset }: { onReset: () => void }) {
  const navigate = useNavigate();
  return (
    <div role="alert" className="m-4 flex flex-col items-center rounded-lg border border-dashed border-graphite-700 px-4 py-16 text-center">
      <AlertTriangle className="mb-3 h-10 w-10 text-danger-400" aria-hidden="true" />
      <p className="text-lg text-graphite-100">Something went wrong.</p>
      <p className="mt-1 text-sm text-graphite-500">
        This page hit a problem, but the rest of the app is still running.
      </p>
      <div className="mt-5 flex flex-wrap justify-center gap-3">
        <Button size="lg" onClick={() => window.location.reload()}>
          Reload
        </Button>
        <Button
          size="lg"
          variant="secondary"
          onClick={() => {
            // Explicit reset too: navigate('/') alone can't reset when the
            // error happened on '/' itself (resetKey wouldn't change).
            onReset();
            navigate('/');
          }}
        >
          Go Home
        </Button>
      </div>
    </div>
  );
}
